var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 28,
    height: 28,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1997 9.1997C9.46597 8.93343 9.89767 8.93343 10.1639 9.1997L14 13.0358L17.8361 9.1997C18.1023 8.93343 18.534 8.93343 18.8003 9.1997C19.0666 9.46597 19.0666 9.89767 18.8003 10.1639L14.9642 14L18.8003 17.8361C19.0666 18.1023 19.0666 18.534 18.8003 18.8003C18.534 19.0666 18.1023 19.0666 17.8361 18.8003L14 14.9642L10.1639 18.8003C9.89767 19.0666 9.46597 19.0666 9.1997 18.8003C8.93343 18.534 8.93343 18.1023 9.1997 17.8361L13.0358 14L9.1997 10.1639C8.93343 9.89767 8.93343 9.46597 9.1997 9.1997Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-icon.73d8ea6c55bc7f64ece93e363138096b.svg";